import React from 'react'

interface LoadingSkeletonProps {
  lines?: number
  height?: string
  className?: string
}

export function LoadingSkeleton({
  lines = 3,
  height = 'h-4',
  className = '',
}: LoadingSkeletonProps) {
  return (
    <div className={`flex flex-col gap-2 w-full ${className}`} role="status" aria-label="Loading">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={`skeleton ${height} rounded ${i === lines - 1 ? 'w-3/4' : 'w-full'}`}
        />
      ))}
    </div>
  )
}

export function CardSkeleton({ className = '' }: { className?: string }) {
  return (
    <div className={`surface p-lg ${className}`}>
      <div className="skeleton h-4 w-1/3 mb-4 rounded" />
      <div className="flex flex-col gap-2">
        <div className="skeleton h-8 w-1/2 rounded" />
        <div className="skeleton h-3 w-2/3 rounded" />
        <div className="skeleton h-3 w-1/2 rounded" />
      </div>
    </div>
  )
}

export function TableRowSkeleton({ cols = 4 }: { cols?: number }) {
  return (
    <tr className="border-b border-border">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-4 py-3">
          <div className="skeleton h-3 rounded w-full" />
        </td>
      ))}
    </tr>
  )
}
